import React, { createContext, useContext, useEffect, useLayoutEffect, useMemo } from 'react';
import { chatWootMaxLinkSelector, contentByRegionMap, ContentTitle, ContentTitles, TContentWithTitle } from './constants';
import { Regions } from 'common/model/account/regions';
import { useDispatch, useSelector } from 'react-redux';
import { clientCurrentRegionSelector } from 'redux/selectors';
import { useGetCurrentMaxCscBotLink } from 'app/shared/hooks/useGetMaxBotLink';
import { getFrontSettings } from 'redux/actions';

const ContentViaRegionContext = createContext<TContentWithTitle | null>(null);

export const useContentViaRegion = (): TContentWithTitle => {
    const context = useContext(ContentViaRegionContext);
    if (!context) {
        throw new Error('useContentViaRegion must be used within ContentViaRegionProvider');
    }
    return context;
};

export const ContentViaRegionProvider = ({ children }: { children: React.ReactNode }) => {
    const currentRegion = useSelector(clientCurrentRegionSelector) as Regions;
    const maxBotLink = useGetCurrentMaxCscBotLink();
    const dispatch = useDispatch();

    const preparedContent = useMemo(() => {
        const regionData = contentByRegionMap[currentRegion] ?? {} as TContentWithTitle;

        const keys = Object.keys(ContentTitles) as ContentTitle[];

        return keys.reduce((acc, key) => {
            acc[key] = regionData[key] ?? contentByRegionMap?.[Regions.TjumenskajaOblast]?.[key];
            return acc;
        }, {} as TContentWithTitle);
    }, [currentRegion]);

    useLayoutEffect(() => {
        const maxItemHtmlElement = document.querySelector(chatWootMaxLinkSelector);

        if ((maxItemHtmlElement?.firstChild as HTMLAnchorElement)?.href) {
            (maxItemHtmlElement?.firstChild as HTMLAnchorElement).href = maxBotLink;
        }

    }, [currentRegion, maxBotLink]);

    useEffect(() => {
        dispatch(getFrontSettings());
    }, [dispatch]);

    return (
        <ContentViaRegionContext.Provider value={preparedContent}>
            {children}
        </ContentViaRegionContext.Provider>
    );
};
